/**
 * Chaise side (LHF/RHF) selector. Two fixed options; selection is written to a
 * hidden `properties[<label>]` input on the product form so it's captured at checkout.
 */
function initChaiseSideOptions(root) {
  const productForm =
    document.getElementById(root.getAttribute('data-product-form-id')) ||
    document.querySelector('form[data-type="add-to-cart-form"]');

  const propertyName = root.getAttribute('data-cart-property') || 'Chaise Side';
  const buttons = root.querySelectorAll('[data-chaise-option]');
  const valueEl = root.querySelector('[data-chaise-selected-value]');

  const inputId = `chaise-side-options-hidden-${root.getAttribute('data-block-id')}`;
  let hiddenInput = document.getElementById(inputId);
  if (!hiddenInput && productForm) {
    hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.id = inputId;
    hiddenInput.name = `properties[${propertyName}]`;
    productForm.appendChild(hiddenInput);
  }

  function select(button) {
    buttons.forEach((btn) => {
      const isSelected = btn === button;
      btn.classList.toggle('chaise-side-options__option--selected', isSelected);
      btn.setAttribute('aria-pressed', String(isSelected));
    });

    const value = button.getAttribute('data-chaise-value');
    const code = button.getAttribute('data-chaise-code');
    if (valueEl) valueEl.textContent = `${value} (${code})`;
    if (hiddenInput) hiddenInput.value = value;
  }

  const preSelected = root.querySelector('.chaise-side-options__option--selected') || buttons[0];
  if (preSelected) select(preSelected);

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => select(btn));
  });
}

function initAllChaiseSideOptions() {
  document.querySelectorAll('[data-chaise-side-options-root]').forEach(initChaiseSideOptions);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllChaiseSideOptions);
} else {
  initAllChaiseSideOptions();
}
